import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import AppNavigation from '@/components/navigation/AppNavigation';
import AdminNavigation from '@/components/navigation/AdminNavigation';
import PublicNavigation from '@/components/navigation/PublicNavigation';
import { ProfileProvider } from '@/contexts/ProfileContext';
import NotFoundPage from './page';

/**
 * Wrapper component that renders the 404 page with the appropriate navigation
 * based on whether the user is authenticated and which section they are in.
 */
const NotFoundWrapper: React.FC = () => {
  const { user } = useAuth();
  const location = useLocation();

  const isAdminPath = location.pathname.startsWith('/admin-tools');

  const renderAuthenticatedNavigation = () => {
    if (isAdminPath && user?.is_system_admin) {
      return <AdminNavigation />;
    }
    
    return (
      <ProfileProvider>
        <AppNavigation />
      </ProfileProvider>
    );
  };

  return (
    <>
      {user ? renderAuthenticatedNavigation() : <PublicNavigation />}
      <NotFoundPage />
    </>
  );
};

export default NotFoundWrapper;
